var TreasureBoxShareInRedirector = xClass("TreasureBoxShareInRedirector", BaseRedirector)
TreasureBoxShareInRedirector.prototype.getName = function () {
    var self = this
    return "treasureBox"
}
TreasureBoxShareInRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
TreasureBoxShareInRedirector.prototype.redirect = function () {
    var self = this
    
    if (isWechatGameEnv() && !mini.supportActivityTreasureBox())
        return true;


    var param = self.param

    //if (META.platform == XcloverPlatform.wechatgame || __DEBUG) 
    {
        let inviteCode, treasureBoxId, redbagTime, shareId
        if (param) {
            inviteCode = param["inviteCode"]
            treasureBoxId = param["treasureBox"]
            redbagTime = param["redbagTime"]
            if (param["shareId"]) {
                if (window.mini && mini.getPlatform() == MiniPlatform.tt && shareId == ""){
                    shareId = null;
                }else{
                    shareId = param["shareId"];
                }
            }
        } else {
            inviteCode = getParameterByName("inviteCode")
            treasureBoxId = getParameterByName("treasureBox")
            redbagTime = getParameterByName("redbagTime")
        }

        console.log("TreasureBoxShareInRedirector", window.mini && mini.getPlatform() == MiniPlatform.tt, shareId)
        if (window.mini && mini.getPlatform() == MiniPlatform.tt){
            var scene = cc.Director.getInstance().getRunningScene()
            if (!scene || scene.name === "PreloadScene") {
                return false
            }
        }

        if (inviteCode && treasureBoxId == 1) {
            let treasureBoxClickInfo = UserLocalSettings.getSetting("treasureBox_shareIn_day_time2", {})
            let uid = UserManager.getInstance().uid
            let info = treasureBoxClickInfo[uid] || {}
            let curT = (new Date()).getTime()
            let lastT = info[inviteCode] || 0
            if (isSameYMD(lastT, curT)) {
                if (inviteCode == uid) {
                    Toast.make("不能帮助自己哦");
                } else {
                    Toast.make("今日已帮助过该好友，不能重复获得奖励");
                }
            } else {
                console.log("#### shareId", shareId)
                if (shareId) {
                    let http = RedbagClickRealShareHttp.new(false)
                    http.addEventListener(Events.kComplete, evt => {
                        info[inviteCode] = curT
                        treasureBoxClickInfo[uid] = info
                        UserLocalSettings.setSetting("treasureBox_shareIn_day_time2", treasureBoxClickInfo)

                        Toast.make("获得免费精力，请于信箱中查看")
                        if(window.EmailManager) {
                            EmailManager.getInstance().forceGetInfo();
                        }
                        // var rewardItems = evt && evt.data && evt.data.rewardItems || table();
                        // for (var k = 1, v = rewardItems[1]; v; k++ , v = rewardItems[k]) {
                        //     UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.GIFT)
                        // }
                    })
                    http.addEventListener(Events.kError, evt => {
                        let code = evt.data
                        Toast.make(getText("error.tip." + code))
                    })
                    http.load(inviteCode, shareId)
                } else {
                    let http = TreasureBoxHelperHttp.new(false)
                    http.load(redbagTime, param.inviteCode)
                    http.addEventListener(Events.kComplete, evt => {
                        let canGet = evt.data && evt.data.canGetEnergy
                        info[inviteCode] = curT
                        treasureBoxClickInfo[uid] = info
                        UserLocalSettings.setSetting("treasureBox_shareIn_day_time2", treasureBoxClickInfo)

                        if (inviteCode == uid) {
                            Toast.make("已成功获得免费精力")
                            return
                        }

                        if (canGet) {
                            Toast.make("获得免费精力，请于信箱中查看")
                            if(window.EmailManager) {
                                EmailManager.getInstance().forceGetInfo();
                            }
                            // UserProp.getInstance().rewardProp(GamePropsType.kEnergy1, 1, null, null, ModuleName.GIFT)
                        } else {
                            Toast.make("今日已帮助过该好友，不能重复获得奖励")
                        }
                    })
                    http.addEventListener(Events.kError, evt => {
                        let code = evt.data
                        Toast.make(getText("error.tip." + code))
                    })
                }
            }
        }
    }

    return true
}
module.exports = TreasureBoxShareInRedirector